import { combineReducers } from 'redux';
import { uploadAmazonAffiliateReportReducer as uploadAmazonAffiliateReport } from './uploadAmazonAffiliateReportReducer';
import { recoverAmazonAffiliateReportsReducer as recoverAmazonAffiliateReports } from './recoverAmazonAffiliateReportsReducer';

export const amazonAffiliateReportsReducers = combineReducers({
  uploadAmazonAffiliateReport,
  recoverAmazonAffiliateReports,
});
